import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as sponsors from '../../../../sponsors'
import * as project from '../project'

export const RESOURCE = {
  payload: {
    canBeOptional: true,
    context: core.dms.models.Attribute.Id.Context.from({
      context: project.RESOURCE.payload.dimension.partialId,
      partialId: project.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    description: 'Sponsor that is connected to this project.',
    isOptional: true,
    name: 'Sponsor',
    partialId: PartialId.Standard.create('sponsor'),
    type: {
      dimensionId: core.dms.models.Dimension.Id.from(sponsors.RESOURCE.payload),
    },
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
